import React, { useState, useEffect } from "react";
import { string } from "prop-types";
import { parseUrl } from "query-string";

import OtpVerification from "../../rows/OtpVerification";
import HeaderWrapper from "../../header/header-wrapper";

const VerifyEmailPage = ({ currentPath }) => {
  const [memberId, setMemberId] = useState(null);

  useEffect(() => {
    const params = parseUrl(currentPath);
    if (params && params.query && params.query.id) {
      setMemberId(params.query.id);
    }
  }, []);

  return (
    <React.Fragment>
      <HeaderWrapper hideTopAd={true} />
      <OtpVerification memberId={memberId} />
    </React.Fragment>
  );
};

VerifyEmailPage.propTypes = {
  currentPath: string
};

export { VerifyEmailPage };
